module.exports = __webpack_public_path__ + "img/arrow_filling.82fb7a62.svg";